<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Edit Loyalty Program</h1>
    </div>

    <div class="container completed-trainings">
      <h1 class="text-center text-uppercase">{{program.name}}</h1>
      <br>
      <div class="completed-trainings-list" v-if="Object.keys(completedTrainings).length > 0">
        <div v-for="(key, index) in Object.keys(completedTrainings)" :key="index">
          <h2>{{ key }}</h2>
          <div class="np-left-push hidden-xs">
            <div class="row">
              <div class="col-sm-12"><strong>Username</strong></div>
            </div>
          </div>
          <div
            class="blue-outline-nh"
            v-for="(training, index) in completedTrainings[key]" :key="index"
          >
            <div class="row">
              <div class="col-sm-12">{{ training.username }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-trainings" v-else>
        No trainings completed
      </div>
      <br>
      <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
      <div class="clearfix"></div>
      <br>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'CompletedTrainings',
  data () {
    return {
      currentUser: null
    }
  },
  computed: {
    ...mapGetters('loyaltyProgram', ['completedTrainings']),
    ...mapState('loyaltyProgram', ['program']),
    ...mapState('user', [ 'users' ])
  },
  methods: {
    ...mapActions('user', [
      'updateUserLoyaltyProgram',
      'deleteUserById'
    ]),
    delete (id) {
      this.deleteUserById(id)
        .then(() => {
          this.$router.push({ name: 'EditLoyaltyProgram' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    goUserDetails (user) {
      this.currentUser = user
    }
  }
}
</script>
